module.exports = __webpack_public_path__ + "static/media/Cairo.c3692d31.png";